var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuallityRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1309 2.15262C20.8934 0.615793 23.1064 0.615795 23.8689 2.15262L28.7559 12.0015C29.0581 12.6107 29.644 13.0336 30.3223 13.1322L41.2705 14.7241C42.9747 14.9719 43.6555 17.0445 42.4244 18.2373L34.493 25.9223C34.0046 26.3954 33.7818 27.0757 33.8968 27.7426L35.7665 38.5869C36.0571 40.2725 34.268 41.5555 32.7409 40.7566L22.9728 35.6464C22.3641 35.3279 21.6357 35.3279 21.027 35.6464L11.2589 40.7566C9.73177 41.5555 7.94271 40.2725 8.23332 38.5869L10.103 27.7426C10.218 27.0757 9.99515 26.3954 9.50679 25.9223L1.5754 18.2373C0.34431 17.0445 1.02505 14.9719 2.72932 14.7241L13.6775 13.1322C14.3558 13.0336 14.9416 12.6107 15.2439 12.0015L20.1309 2.15262Z",
    fill: "#BABFFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.027 35.6464L11.2589 40.7566C9.73177 41.5555 7.94271 40.2725 8.23332 38.5869L10.103 27.7426C10.218 27.0757 9.99515 26.3954 9.50679 25.9223L1.5754 18.2373C0.34431 17.0445 1.02505 14.9719 2.72932 14.7241L13.6775 13.1322C14.3558 13.0336 14.9416 12.6107 15.2439 12.0015L20.1309 2.15262C20.8934 0.615793 23.1064 0.615795 23.8689 2.15262L28.7559 12.0015M35.7665 38.5869L33.8968 27.7426C33.7818 27.0757 34.0046 26.3954 34.493 25.9223L42.4244 18.2373C42.7284 17.9428 42.9158 17.5947 43 17.2336",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009436"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1212",
    cx: 21.4781,
    cy: 23.1258,
    rx: 9.37067,
    ry: 9.27743,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250847",
    d: "M16.5947 23.0507C16.384 22.8722 16.0685 22.8983 15.89 23.1089C15.7115 23.3196 15.7376 23.6351 15.9483 23.8137L16.5947 23.0507ZM19.5596 26.2182L19.2364 26.5997L19.5899 26.8992L19.9154 26.5695L19.5596 26.2182ZM27.1833 18.9992C27.1816 18.7231 26.9563 18.5007 26.6801 18.5025L22.1802 18.5313C21.9041 18.5331 21.6817 18.7584 21.6834 19.0345C21.6852 19.3107 21.9105 19.5331 22.1866 19.5313L26.1866 19.5056L26.2122 23.5056C26.214 23.7817 26.4393 24.0041 26.7154 24.0023C26.9916 24.0006 27.214 23.7753 27.2122 23.4991L27.1833 18.9992ZM15.9483 23.8137L19.2364 26.5997L19.8828 25.8367L16.5947 23.0507L15.9483 23.8137ZM19.9154 26.5695L27.0392 19.3537L26.3275 18.6512L19.2038 25.8669L19.9154 26.5695Z",
    fill: "#383434"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuallityRate);
export default __webpack_public_path__ + "static/media/QuallityRate.7a3599e67ba15f3498e7b581c422f0ed.svg";
export { ForwardRef as ReactComponent };